<div class="w-full bg-white p-3 md:p-5">
  <p-toast></p-toast>
  <p-confirmDialog
    [breakpoints]="{'960px': '75vw', '640px': '90vw'}"
    [style]="{width: '50vw'}"
    acceptLabel="Sí"
    rejectLabel="Cancelar"
    rejectButtonStyleClass="p-button-danger">
  </p-confirmDialog>

  <div class="flex flex-column md:flex-row justify-content-between align-items-center gap-3 mb-5">
    <div class="w-full md:w-auto">
      <span class="p-input-icon-left w-full md:w-auto">
        <i class="pi pi-search"></i>
        <input pInputText type="text" [(ngModel)]="search" (input)="scheduleServerLoad()"
               placeholder="Buscar producto..."
               class="w-full md:w-20rem border-round-3xl input-search" />
      </span>
      <small class="text-500 block mt-2">Búsqueda y estado en el servidor.</small>
    </div>

    <div class="flex flex-wrap gap-2 w-full md:w-auto justify-content-end">
      <p-select [options]="activeOptions" [(ngModel)]="activeFilter" (onChange)="reloadFirst()"
                optionLabel="label" optionValue="value" placeholder="Estado"
                class="w-full sm:w-auto" [showClear]="true"></p-select>

      <button pButton icon="pi pi-filter-slash" class="p-button-outlined p-button-secondary border-round-3xl"
              (click)="clearFilters()" pTooltip="Limpiar filtros"></button>

      <button pButton label="Nuevo" icon="pi pi-plus" class="p-button-black border-round-3xl"
              (click)="openNew()"></button>
    </div>
  </div>

  <p-table [value]="products" [lazy]="true" (onLazyLoad)="loadProducts($event)"
           [first]="first" [rows]="rows" [totalRecords]="totalRecords" [paginator]="true"
           [rowsPerPageOptions]="[10, 25, 50]"
           [loading]="loading"
           [tableStyle]="{ 'min-width': '60rem' }"
           [rowHover]="true"
           styleClass="p-datatable-sm">

    <ng-template pTemplate="header">
      <tr class="uppercase text-xs text-500">
        <th style="width: 5rem">Img</th>
        <th>Producto</th>
        <th>Atributos</th>
        <th class="text-center">Precios y Ofertas</th>
        <th class="text-center">Stock Total</th>
        <th class="text-center">Estado</th>
        <th class="text-center" style="width: 150px">Acciones</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-product>
      <tr class="text-sm">
        <td>
          <div class="border-1 surface-border border-round overflow-hidden flex align-items-center justify-content-center cursor-pointer"
               style="width: 50px; height: 50px;" (click)="showProductDetails(product)">
            <img [src]="product.image" [alt]="product.name" class="w-full h-full" style="object-fit: cover;" />
          </div>
        </td>
        <td>
          <span class="font-bold block text-900 cursor-pointer" (click)="showProductDetails(product)">{{ product.name }}</span>
          <span class="text-xs text-500">SKU: {{ product.sku || '-' }}</span>
        </td>
        <td>
          <div class="flex flex-column gap-2">
            <div class="flex align-items-center gap-2" *ngIf="product.color">
              <div class="w-1rem h-1rem border-circle border-1 border-300"
                   [style.background-color]="product.color">
              </div>
              <span class="text-xs text-600">{{ product.colorName || 'N/A' }}</span>
            </div>
            <span class="text-xs text-600">{{ product.categoryName || 'Sin categoría' }} · {{ product.brandName || 'Sin marca' }}</span>
            <span class="text-xs text-500" *ngIf="product.modeloName">{{ product.modeloName }}</span>
          </div>
        </td>
        <td class="text-center">
          <button pButton
                  [label]="(product.tipoMonedaSimbolo || 'S/') + ' ' + (listPrice(product) | number:'1.2-2')"
                  [class]="product.isOffer ? 'p-button-rounded p-button-warning p-button-sm' : 'p-button-rounded p-button-text p-button-secondary p-button-sm'"
                  (click)="showPriceDetails(product)"
                  pTooltip="Ver desglose de precios por talla">
          </button>
          <span *ngIf="showsStruckPrice(product)" class="block text-xs text-400 line-through mt-1">
            {{ product.tipoMonedaSimbolo || 'S/' }} {{ product.price | number:'1.2-2' }}
          </span>
          <span *ngIf="offerBySize(product)" class="block text-xs text-orange-600 mt-1">Oferta por talla</span>
        </td>
        <td class="text-center">
          <span [class]="'text-xs font-bold px-2 py-1 border-round ' + (product.stock > 10 ? 'bg-green-100 text-green-700' : (product.stock > 0 ? 'bg-yellow-100 text-yellow-700' : 'bg-red-100 text-red-700'))">
            {{product.stock}} u.
          </span>
        </td>
        <td class="text-center">
          <p-tag [severity]="product.isActive ? 'success' : 'danger'" [value]="product.isActive ? 'ACTIVO' : 'INACTIVO'" [rounded]="true"></p-tag>
        </td>
        <td class="text-center">
          <div class="flex justify-content-center gap-1">
            <button pButton icon="pi pi-eye" class="p-button-text p-button-rounded text-blue-500" (click)="showProductDetails(product)" pTooltip="Ver Detalle"></button>
            <button pButton icon="pi pi-pencil" class="p-button-text p-button-rounded text-600" (click)="editProduct(product)" pTooltip="Editar"></button>
            <button pButton icon="pi pi-tag" class="p-button-text p-button-rounded text-orange-500" (click)="manageOffer(product)" pTooltip="Ofertas"></button>
            <button pButton icon="pi pi-power-off" class="p-button-text p-button-rounded" [ngClass]="product.isActive ? 'text-red-400' : 'text-green-400'" (click)="deleteProduct(product)"></button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7" class="text-center text-500 py-5">
          {{ loading ? 'Cargando...' : 'No hay productos con este filtro.' }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog [(visible)]="priceDetailsDialog" header="Lista de Precios y Ofertas" [modal]="true" [style]="{width: '450px'}">
  <div *ngIf="selectedProductView" class="pt-2">
    <div class="flex justify-content-between align-items-center mb-4 p-3 bg-bluegray-50 border-round">
      <span class="font-bold text-700">PRECIO BASE:</span>
      <span class="text-2xl font-black text-primary">{{selectedProductView.price | currency:'PEN'}}</span>
    </div>

    <div class="flex flex-column gap-1">
      <div *ngFor="let item of selectedProductView.stockDetails" class="grid align-items-center p-2 border-bottom-1 surface-border">
        <div class="col-3 font-bold">{{item.sizeName}}</div>
        <div class="col-4 text-center">
          <p-tag [value]="item.quantity + ' ud.'" [severity]="item.quantity === 0 ? 'danger' : 'info'"></p-tag>
        </div>
        <div class="col-5 text-right">
          <div *ngIf="!selectedProductView.isOffer" class="font-bold">
            {{item.price | currency:'PEN'}}
          </div>

          <div *ngIf="selectedProductView.isOffer">
            <ng-container *ngIf="(selectedProductView.offerScope === 'GLOBAL' && selectedProductView.globalDiscountValue > 0) || (selectedProductView.offerScope === 'BY_SIZE' && item.discountValue > 0)">
              <div class="text-xs line-through text-400">{{item.price | currency:'PEN'}}</div>
            </ng-container>

            <div class="font-bold text-orange-600">
      <span *ngIf="selectedProductView.offerScope === 'GLOBAL'">
        {{ (selectedProductView.globalDiscountType === '%'
        ? (item.price * (1 - (selectedProductView.globalDiscountValue || 0)/100))
        : (item.price - (selectedProductView.globalDiscountValue || 0))) | currency:'PEN' }}
      </span>

              <span *ngIf="selectedProductView.offerScope === 'BY_SIZE'">
        {{ (item.discountValue > 0
                ? (item.discountType === '%' ? (item.price * (1 - item.discountValue/100)) : (item.price - item.discountValue))
                : item.price) | currency:'PEN' }}
      </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="viewProductDialog" header="Ficha Técnica del Producto" [modal]="true" [style]="{width: '700px'}" [breakpoints]="{'960px': '90vw'}" [draggable]="false">
  <div *ngIf="selectedProductView" class="grid pt-2">
    <div class="col-12 md:col-5">
      <div class="border-round overflow-hidden shadow-2 surface-border border-1">
        <img [src]="selectedProductView.image" class="w-full block" style="object-fit: contain; max-height: 350px;" />
      </div>
      <div class="mt-3 grid text-center">
        <div class="col-6">
          <span class="text-xs font-bold text-500 block uppercase">Stock Total</span>
          <span class="text-xl font-bold">{{selectedProductView.stock}}</span>
        </div>
        <div class="col-6">
          <span class="text-xs font-bold text-500 block uppercase">Estado</span>
          <p-tag [severity]="selectedProductView.isActive ? 'success' : 'danger'" [value]="selectedProductView.isActive ? 'ACTIVO' : 'INACTIVO'"></p-tag>
        </div>
      </div>
    </div>
    <div class="col-12 md:col-7 pl-0 md:pl-4">
      <h2 class="m-0 text-900 border-bottom-1 surface-border pb-2">{{selectedProductView.name}}</h2>

      <div class="grid mt-3">
        <div class="col-6 mb-2">
          <span class="text-xs font-bold text-500 block">MARCA</span>
          <span class="text-900 font-medium">{{selectedProductView.brandName || 'N/A'}}</span>
        </div>
        <div class="col-6 mb-2">
          <span class="text-xs font-bold text-500 block">CATEGORÍA</span>
          <span class="text-900 font-medium">{{selectedProductView.categoryName || 'N/A'}}</span>
        </div>
        <div class="col-6 mb-2">
          <span class="text-xs font-bold text-500 block">MODELO</span>
          <span class="text-900 font-medium">{{selectedProductView.modelNameDisplay}}</span>
        </div>
        <div class="col-6 mb-2">
          <span class="text-xs font-bold text-500 block">SKU</span>
          <span class="text-900 font-medium">{{selectedProductView.sku || '-'}}</span>
        </div>
        <div class="col-6 mb-2">
          <span class="text-xs font-bold text-500 block">COLOR</span>
          <div class="flex align-items-center gap-2 mt-1">
            <div class="w-1rem h-1rem border-circle border-1 border-300" [style.background-color]="selectedProductView.color"></div>
            <span class="text-900 font-medium">{{selectedProductView.colorName}}</span>
          </div>
        </div>
      </div>

      <div class="mt-3">
        <span class="text-xs font-bold text-500 block mb-1">DESCRIPCIÓN</span>
        <p class="m-0 text-700 line-height-3 text-sm surface-50 p-2 border-round">{{selectedProductView.description || 'Sin descripción disponible.'}}</p>
      </div>

      <div class="mt-4">
        <span class="text-xs font-bold text-500 block mb-2">DISPONIBILIDAD POR TALLA</span>
        <div class="flex flex-wrap gap-2">
          <div *ngFor="let s of selectedProductView.stockDetails" class="px-3 py-2 border-1 surface-border border-round bg-white shadow-sm flex align-items-center gap-2">
            <span class="font-bold text-primary">{{s.sizeName}}</span>
            <span class="text-xs text-500">|</span>
            <span class="text-xs font-medium">{{s.quantity}} ud.</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="productDialog" header="Gestión de Producto" [modal]="true"
          styleClass="p-fluid"
          [breakpoints]="{'960px': '75vw', '640px': '95vw'}"
          [style]="{ width: '70vw' }"
          [draggable]="false" [resizable]="false">

  <ng-template pTemplate="content">
    <div class="grid pt-3">
      <div class="col-12 md:col-4 flex flex-column gap-3">
        <div class="border-2 border-dashed surface-border border-round p-3 flex align-items-center justify-content-center relative bg-surface-50" style="aspect-ratio: 1;">
          <img *ngIf="product.image" [src]="product.image" class="w-full h-full" style="object-fit: contain;">
          <div *ngIf="!product.image" class="text-center text-400">
            <i class="pi pi-image text-4xl mb-2"></i>
            <p class="m-0 text-sm">Vista Previa</p>
          </div>
        </div>
        <div class="field">
          <label for="imgUrl" class="text-xs font-bold">URL de Imagen</label>
          <input pInputText id="imgUrl" [(ngModel)]="product.image" />
        </div>
        <div class="field">
          <label for="model3d" class="text-xs font-bold">URL Modelo 3D</label>
          <input pInputText id="model3d" [(ngModel)]="product.model3d" />
        </div>
      </div>

      <div class="col-12 md:col-8">
        <div class="formgrid grid">
          <div class="field col-12">
            <label class="font-bold">Nombre del Producto</label>
            <input pInputText [(ngModel)]="product.name" required />
            <small class="p-error block" *ngIf="submitted && !product.name">El nombre es requerido.</small>
          </div>

          <div class="field col-12 md:col-4">
            <label>Categoría</label>
            <p-select [options]="categories" [(ngModel)]="product.categoryId" (onChange)="onCategoryChange($event)"
                      optionLabel="name" optionValue="id" placeholder="Seleccionar" appendTo="body"></p-select>
          </div>

          <div class="field col-12 md:col-4">
            <label>Modelo</label>
            <p-select [options]="filteredModels" [(ngModel)]="product.modelId"
                      optionLabel="name" optionValue="id" [disabled]="filteredModels.length === 0"
                      placeholder="Seleccionar Modelo" appendTo="body"></p-select>
          </div>

          <div class="field col-12 md:col-4">
            <label>Marca</label>
            <p-select [options]="brands" [(ngModel)]="product.brandId" optionLabel="name" optionValue="id" placeholder="Seleccionar" appendTo="body"></p-select>
          </div>

          <div class="field col-12 md:col-4">
            <label>Tipo de moneda</label>
            <p-select [options]="tiposMoneda" [(ngModel)]="product.tipoMonedaId" optionLabel="nombreMoneda" optionValue="id" placeholder="Moneda" appendTo="body" [showClear]="true"></p-select>
          </div>

          <div class="field col-6">
            <label>Precio Base (S/)</label>
            <p-inputNumber [(ngModel)]="product.price" mode="currency" currency="PEN" locale="es-PE" [min]="0.01"></p-inputNumber>
            <small class="p-error block" *ngIf="submitted && !(product.price > 0)">El precio base debe ser mayor a 0.</small>
          </div>

          <div class="field col-6">
            <label>Stock Total (Calculado)</label>
            <p-inputNumber [ngModel]="calculatedTotalStock" [disabled]="true" class="opacity-60 font-bold text-900"></p-inputNumber>
          </div>

          <div class="field col-12 md:col-6">
            <label>Color</label>
            <p-select [options]="colorsList" [(ngModel)]="selectedColorId"
                      optionLabel="name" optionValue="id" placeholder="Seleccionar Color"
                      appendTo="body" [showClear]="true">
              <ng-template let-c pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <div class="w-1rem h-1rem border-circle border-1 border-300" [style.background-color]="c.hexCode"></div>
                  <span>{{c.name}}</span>
                </div>
              </ng-template>
              <ng-template let-c pTemplate="selectedItem">
                <div class="flex align-items-center gap-2" *ngIf="c">
                  <div class="w-1rem h-1rem border-circle border-1 border-300" [style.background-color]="c.hexCode"></div>
                  <span>{{c.name}}</span>
                </div>
              </ng-template>
            </p-select>
          </div>

          <div class="field col-12 md:col-6">
            <label>Tallas Disponibles</label>
            <p-multiSelect [options]="sizesList" [(ngModel)]="product.sizeIds" (onChange)="onSizesChange($event)"
                           optionLabel="name" optionValue="id" placeholder="Seleccionar tallas" display="chip" appendTo="body"></p-multiSelect>
          </div>

          <div class="field col-12 bg-surface-50 p-3 border-round border-1 border-200 mt-2" *ngIf="product.sizeIds && product.sizeIds.length > 0">
            <label class="font-bold text-900 block mb-3 italic">Inventario y Precios:</label>
            <div class="grid mb-2 pb-2 border-bottom-1 surface-border font-bold text-xs text-500 hidden md:flex">
              <div class="col-3">Talla</div>
              <div class="col-4">Stock</div>
              <div class="col-5">Precio Unitario (S/)</div>
            </div>
            <div class="grid mb-3 pb-3 border-bottom-1 surface-border align-items-center" *ngFor="let sizeId of product.sizeIds">
              <div class="col-12 md:col-3">
                <span class="text-base font-bold text-700">{{ getSizeName(sizeId) }}</span>
              </div>
              <div class="col-6 md:col-4">
                <p-inputNumber [(ngModel)]="sizeDetailsMap[sizeId].quantity" [min]="0" [showButtons]="true" placeholder="Cantidad"></p-inputNumber>
              </div>
              <div class="col-6 md:col-5">
                <p-inputNumber [(ngModel)]="sizeDetailsMap[sizeId].price" mode="currency" currency="PEN" locale="es-PE" placeholder="Precio" [min]="0"></p-inputNumber>
              </div>
            </div>
          </div>

          <div class="field col-12 mt-2">
            <label>Descripción</label>
            <textarea pTextarea [(ngModel)]="product.description" rows="3" class="w-full"></textarea>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text text-900" (click)="hideDialog()"></button>
    <button pButton label="Guardar Producto" icon="pi pi-check" class="p-button-black" (click)="saveProduct()"></button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="offerDialog" header="Gestionar Ofertas Web" [modal]="true"
          [breakpoints]="{'960px': '75vw', '640px': '95vw'}"
          [style]="{ width: '500px' }" styleClass="p-fluid" [draggable]="false">

  <div class="flex flex-column gap-4 pt-2">
    <div class="surface-100 p-3 border-round">
      <h3 class="m-0 text-900">{{ selectedProductForOffer?.name }}</h3>
      <div class="text-600">Precio Base: <span class="font-bold">{{ selectedProductForOffer?.price | currency:'PEN' }}</span></div>
    </div>

    <div class="field-checkbox bg-surface-50 p-3 border-round border-1 surface-border">
      <p-checkbox [(ngModel)]="offerData.isOfferActive" [binary]="true" inputId="offerActive"></p-checkbox>
      <label for="offerActive" class="ml-2 cursor-pointer select-none text-900 font-bold">Activar oferta en la web</label>
    </div>

    <div *ngIf="offerData.isOfferActive" class="flex flex-column gap-4 animation-duration-200 fadein">
      <div class="field">
        <label class="block font-bold mb-2 text-xs uppercase text-500">Alcance del Descuento</label>
        <div class="flex gap-4">
          <div class="flex align-items-center">
            <p-radioButton name="scope" value="GLOBAL" [(ngModel)]="offerData.offerScope" inputId="sc1"></p-radioButton>
            <label for="sc1" class="ml-2">Global</label>
          </div>
          <div class="flex align-items-center">
            <p-radioButton name="scope" value="BY_SIZE" [(ngModel)]="offerData.offerScope" inputId="sc2"></p-radioButton>
            <label for="sc2" class="ml-2">Por Talla</label>
          </div>
        </div>
      </div>

      <div *ngIf="offerData.offerScope === 'GLOBAL'" class="grid animation-duration-200 fadein">
        <div class="col-6">
          <label class="block font-bold mb-1 text-xs">Tipo</label>
          <p-select [options]="[{l: 'Monto (S/)', v: 'S/'}, {l: 'Porcentaje (%)', v: '%'}]"
                    [(ngModel)]="offerData.globalDiscountType" optionLabel="l" optionValue="v" appendTo="body"></p-select>
        </div>
        <div class="col-6">
          <label class="block font-bold mb-1 text-xs">Valor Descuento</label>
          <p-inputNumber [(ngModel)]="offerData.globalDiscountValue" [min]="0" placeholder="0.00"></p-inputNumber>
        </div>
        <div class="col-12 mt-2">
          <div class="p-2 border-round bg-yellow-50 text-yellow-700 text-xs border-1 border-yellow-200">
            <i class="pi pi-info-circle mr-1"></i> El descuento global se aplicará sobre el precio de todas las tallas.
          </div>
        </div>
      </div>

      <div *ngIf="offerData.offerScope === 'BY_SIZE'" class="flex flex-column gap-2 animation-duration-200 fadein">
        <label class="block font-bold mb-1 text-xs uppercase text-500">Configuración por Talla</label>
        <div *ngFor="let s of offerData.sizeSpecificOffers" class="grid align-items-center py-2 border-bottom-1 surface-border">
          <div class="col-3 font-bold text-sm">{{s.sizeName}}</div>
          <div class="col-4">
            <p-inputNumber [(ngModel)]="s.discountValue" placeholder="Valor" [min]="0" styleClass="p-inputtext-sm"></p-inputNumber>
          </div>
          <div class="col-5">
            <p-select [options]="[{l: 'S/', v: 'S/'}, {l: '%', v: '%'}]"
                      [(ngModel)]="s.discountType" optionLabel="l" optionValue="v"
                      appendTo="body" styleClass="p-inputtext-sm"></p-select>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text text-900" (click)="offerDialog = false"></button>
    <button pButton label="Guardar Oferta" icon="pi pi-check" class="p-button-black" (click)="saveOffer()"></button>
  </ng-template>
</p-dialog>